<style lang='scss' scoped>
.nav-projects {
	.nav-header {
		font-size: 16px;
		padding: 9px;
		font-weight: 700;
	}
	position: fixed;
	top: 50px;
	left: 290px;
	right: 0;
	max-height: calc(100% - 50px);
	z-index: 100;
	background-color: #09659A;
	color: #fff;
	overflow: auto;
	.nav-project {
		padding: 0 12px;
		border-bottom: 1px solid #fff;
		// display: flex;
		// flex-direction: row;
		// flex-wrap: wrap;
		// justify-content: flex-start;
		// align-items: flex-start;
		// align-content: flex-start;
		// column-count: auto;
		column-width: 200px;
		& > div {
			padding: 12px;
			width: min-content;
			height: 100%;
			overflow: auto;
		}
	}
	.nav-item {
		display: block;
		user-select: none;
		padding: 0px 8px 6px 10px;
		color: #a6a6a6;
		&:hover {
			color: #4093ff;
		}
	}
	.nav-btn {
		display: flex;
		justify-content: center;
		span {
			color: #a6a6a6;
			cursor: pointer;
			margin: 12px;
			padding: 8px 16px;
			border-radius: 3px;
			border: 1px solid #fcfcfc;
			&:hover {
				color: #fcfcfc;
			}
		}
	}
    .closeicon{
        font-size: 40px;
        position: absolute;
        right: 20px;
        cursor: pointer;
    }
}
</style>


<template>
	<section class="nav-projects">
        <span><Icon type="ios-close-circle-outline" class="closeicon" @click="cancel" /></span>
		<div class="nav-project">
			<template v-for="(items,index) in moduleList">
				<div v-if="getModuleMap[items.id]" :key="index">
					<header class="nav-header">{{$t(items.langKey,{defaultValue:items.title})}}</header>
					<div v-for="(item,key) of getModuleMap[items.id]" :key="key" >
                        <div class="font-bold" style="margin-left:10px;margin-bottom:4px">{{$t(item.langKey,{defaultValue:item.title})}}</div>
                        <div v-for="(json,index) of getThreeMeList(item.linklistId)" :key="index" class="nav-item">
                            <vCheckBox
							v-model="checked"
							:trueValue="json.id"
							:strict="false"
						>{{$t(json.langKey,{defaultValue:json.title})}}</vCheckBox>
                        </div>
					</div>
				</div>
			</template>
		</div>
		<div class="nav-btn">
			<span @click="updateNavMenu">{{$t('global.common.update_OK')}}</span>
			<span @click="cancel">{{$t('global.common.cancel')}}</span>
		</div>
	</section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { HttpSaveNavMenu } from '../../../../service/base';
export default {
	data() {
		return {
			checked: [],
		};
	},
	created() {
		this.checked = [...this.navTitleIds].filter(id => this.getMenuList[id]);
	},
	// watch: {
	// 	checked(val, old) {
	// 		if (val.length > 8) {
	// 			this.$VMessage.warning(this.$t('global.common.maxlist', { count: 8 }), true);
	// 			this.checked = val.slice(0, 8);
	// 		}
	// 	}
	// },
	computed: {
		...mapState('layout', ['navTitleIds', 'moduleList']),
		...mapGetters('layout', ['getModuleMap', 'getMenuList']),
		// sortModuleList() {
		// 	return Object.values(this.moduleList).sort((pre, next) => {
		// 		const nextModuleMap = this.getModuleMap[next.id] || '', preModuleMap = this.getModuleMap[pre.id] || ''
		// 		return preModuleMap.length - nextModuleMap.length;
		// 	})
		// },
	},
	methods: {
		...mapMutations('layout', ['setNavTitleIds']),
		cancel() {
			this.$parent.visible = false;
		},
        getThreeMeList (moduid) {
            if (!moduid) return;
            let menuList = this.getMenuList
            let arr = [];
            Object.keys(menuList).forEach(function (key) {
                // console.log(key)
                moduid.forEach(function (id) {
                if (menuList[key].id === id) {
                    arr.push(menuList[key])
                }
                })
            });
            arr = arr.sort(this.compareAttribute('sortIndex'))
            return arr;
        },
		updateNavMenu() {
			console.log(this.checked,'this.checked')
            const ids = this.checked;

			HttpSaveNavMenu({ resourceIds: ids.join(',') }).then(res => {
                this.$VMessage.success('操作成功，请到 我的收藏 查看！')
				this.cancel();
				this.setNavTitleIds(ids);
			}).catch(err => {
				this.$VMessage.error(err.message);
			})
		}
	},
};
</script>
